import React from 'react'; 
import { Outlet } from 'react-router-dom';

const WhiteSimpleLayout = () => {
  return (
    <div style={{backgroundColor:'white'}}>
      <Outlet/>
    </div>
  );
};

export default WhiteSimpleLayout;
